import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MobileProfileStore {

}

export enum MobileProfileStoreKeys {

}
